import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useParams } from 'react-router-dom';
import { type EmployeeDetailed } from '@/schemas/API/GET/employee/response';

/**
 * Hook that fetches employee based on the employeeId in the URL.
 */
const useEmployee = () => {
  const { employeeId } = useParams<{ employeeId: string }>();

  const {
    data: employee,
    error,
    mutate,
  } = useSWR<EmployeeDetailed>(
    employeeId ? `/employees/${employeeId}` : null,
    getFetcher
  );

  return {
    employee,
    error,
    mutate,
  };
};

export default useEmployee;
